import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router/router";
import store from "./store/store";
import Vuebar from "vuebar";
import "./plugins/base";
import InstantSearch from "vue-instantsearch";
import veeValidateMixins from "./mixins/veeValidateMixins.js";
import i18n from "./i18n";
import axiosInterceptors from "@/utils/axiosInterceptors";
import { VueReCaptcha } from "vue-recaptcha-v3";
import VueApexCharts from "vue-apexcharts";
import VueHtmlToPaper from "vue-html-to-paper";
import VuePaycard from "vue-paycard";
import VueHtml2pdf from "vue-html2pdf";
import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

Vue.use(PerfectScrollbar);
Vue.use(VueHtml2pdf);

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
  timeout: 1000, // default timeout before the print window appears
  autoClose: false, // if false, the window will not close after printing
  windowTitle: "", // override the window title
};

Vue.use(VueHtmlToPaper, options);

Vue.use(VueApexCharts);

Vue.component("apex-charts", VueApexCharts);

//vue mixin ile global vee validate tanımı
Vue.mixin(veeValidateMixins);

Vue.use(InstantSearch);
Vue.config.productionTip = false;
Vue.use(Vuebar);

// For more options see below
Vue.use(VueReCaptcha, {
  siteKey: "6Lftlf0gAAAAAFbfPF-sDD3z2NO_PSADUkCfP5fv",
  loaderOptions: {
    useRecaptchaNet: true,
  },
});

new Vue({
  vuetify,
  store,
  router,
  i18n,
  axiosInterceptors,
  VuePaycard,
  render: (h) => h(App),
}).$mount("#app");
